import { Outlet } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { SideNav } from './SideNav'
import { StaffViewBanner } from './StaffViewBanner'
import { usePushSync } from '@/features/push/usePushDevice'
import { meQuery } from '@/lib/queries'

/* Spec PWA-001 — moldura de toda a area autenticada. No celular nao acrescenta nada (a barra inferior
   fica no AppShell das abas); em telas largas (>= lg) poe o menu lateral fixo e desloca o conteudo.
   PWA-014 D-04: com sessao, mantem a inscricao deste aparelho em dia (e no idioma atual), sem mostrar nada. */
export function AuthLayout() {
    // COG-009 §4.6: na visualizacao do atendimento (painel), a faixa "somente leitura" e nada de inscrever o aparelho
    const staffView = useQuery(meQuery).data?.staffView === true
    usePushSync(!staffView)
    return (
        <>
            {staffView && <StaffViewBanner />}
            <SideNav className="hidden lg:flex" />
            <div className="lg:pl-64">
                <Outlet />
            </div>
        </>
    )
}
